import React, { useEffect, useReducer, useRef } from 'react'
import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import { getGenericRow } from 'ps-components/AdvancedTable/GenericGrid/GenericGridFunctions';
import { AdvancedTableColumnI, USState, USStateAbbreviated } from '../../../../../lib/types';
import { Button, Select } from '../../../../../ps-aspect-design';
import { AddMinimumWageModal, DeleteWageConfirmationModal, EditMinimumWageModal } from './Modals';
import { TableActionsCell } from './TableActionsCell';
import { getMininumWages, stateAbbrToName, formatDate } from './helpers';
import { initialState, reducer, MinimumWageTableI } from './store';
import './MinimumWageTable.scss'

export const MinimumWageTable: React.FC = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { rows, filteredState, requestPending } = state
  const ref = useRef()

  const minimumWageTableColumns: AdvancedTableColumnI<MinimumWageTableI>[] = [
    { Header: 'State', width: 10, accessor: 'state', customRender: ({ state }) => <div>{stateAbbrToName(state)}</div> },
    { Header: 'City', width: 10, accessor: 'city' },
    { Header: 'Minimum Wage', centerAlign: true, width: 10, accessor: 'minimum_wage', customRender: ({ minimum_wage }) => <div>{minimum_wage ? '$' + parseFloat(minimum_wage.toString()).toFixed(2) : ''}</div> },
    { Header: 'Effective Date', width: 60, accessor: 'effective_date', customRender: ({ effective_date }) => <div>{formatDate(effective_date)}</div> },
    { Header: ' ', width: 10, customRender: (data) => TableActionsCell({ data, dispatch }) }
  ]

  const genRowData = (rows: MinimumWageTableI[], stateFilter: USState | 'All States') => {
    if (stateFilter === 'All States') return rows
    return rows.filter(row => stateAbbrToName(row.state) === stateFilter)
  }

  useEffect(() => {
    getMininumWages(dispatch)
  }, [])

  return (
    <>
      <AddMinimumWageModal state={state} dispatch={dispatch} />
      <EditMinimumWageModal state={state} dispatch={dispatch} />
      <DeleteWageConfirmationModal state={state} dispatch={dispatch} />
      <div className='minimum-wage-table'>
        <div className='minimum-wage-table__state-select'>
          <Select
            componentRef={ref as any}
            disabled={false}
            handleChange={(val: USState) => dispatch({ type: 'SET_FILTERED_STATE', payload: val })}
            options={[{ text: 'All States', key: 'ALL_STATES' }, ...[... new Set(rows.map(r => r.state))].map((s: USStateAbbreviated) => ({ text: stateAbbrToName(s), key: s }))]}
            value={filteredState}
          />
        </div>
        <Button icon='Plus' onClick={() => dispatch({ type: 'SET_ADD_MODAL_OPEN' })}>Add</Button>
      </div>
      <AdvancedTable
        stickyHeader
        columnHeaders={minimumWageTableColumns}
        rowData={genRowData(rows, filteredState)}
        getDataRow={getGenericRow}
        dataLoading={requestPending}
        loadingText={'Loading Minimum Wage Data'}
      />
    </>
  )
}
